//import '../styles/engage.scss';

import noUiSlider from 'nouislider';
import toast from 'siiimple-toast'
import autocomplete from "autocompleter";

//todo: move jquery nice select to vendor
import './jquery-nice-select';


import './quote';
import './sliders';
import './form';
import './import';
import './header';
import './checkout';


//import DualRangeSlider from './range-slider';

jQuery(function ($) {
    var customToast = toast.setOptions({
        container: 'body',
        class: 'siiimpleToast',
        position: 'bottom|center',
        margin: 15,
        delay: 0,
        duration: 3000,
        style: {},
    });

    //customToast.success('Successfully processed', { duration: 5000});
    /*
    customToast.alert('Something seems to be wrong', { duration: 5000});*/
// alert message
    //customToast.alert('Something seems to be wrong');

    //nice select

    $("a[href*='#']").click(function (e) {
        let id = $(this).attr('href');
        id = id.split('#')[1];
        if(id){
            if($('#' + id).length){
                e.preventDefault();
                scrollToElement(id);
            }
        }
    });


    $('select').niceSelect();
    $('select').change(function () {
        if($(this).val() === ""){
            $(this).parent().removeClass('selected');
        }else{
            $(this).parent().addClass('selected');
        }
    });

    $(document).on('click', '.add-to-favorite-link', function (e) {
        e.preventDefault();
        let $this = $(this);
        let removeURL = $(this).attr('remove-href');
        let addURL = $(this).attr('add-href');
        let inFavorite = false;
        let url;
        if($(this).hasClass('in-favorite')){
            inFavorite = true;
            url = removeURL;
            $this.html('<i class="far fa-heart"></i>');
        }else{
            $this.html('<i class="fas fa-heart"></i>');
            url = addURL;
        }
        $.get(url).then(function (respond) {
            if(inFavorite){
                //customToast.success('Removed', { duration: 5000});
                $this.removeClass('in-favorite');
                $this.attr('href', addURL);
            }else{
                //customToast.success('Added', { duration: 5000});
                $this.addClass('in-favorite');
                $this.attr('href', removeURL);
            }
            let counter = parseInt(respond);
            if(counter == 0){
                $(".header--quick-assess__favorite .counter").remove();
            }else{
                if(!$(".header--quick-assess__favorite .counter").length){
                    $(".header--quick-assess__favorite").append('<span class="counter"></span>');
                }
                $(".header--quick-assess__favorite .counter").html(counter);
            }
        })
    });

    if($('.container--category').length){
        submitFilterForm();

        var maxPrice = parseInt($('#to-price').val());
        var priceSlider = document.getElementById('price-slider');

        noUiSlider.create(priceSlider, {
            start: [0, maxPrice],
            connect: true,
            step: 5,
            margin: 10,
            range: {
                'min': 0,
                'max': maxPrice
            },
            format: {
                to: function (value) {
                    return parseInt(value);
                },
                from: function (value) {
                    return parseInt(value);
                }
            }
        });

        priceSlider.noUiSlider.on('slide', function (e) {
            $(".price-slider-detail").html(`$${e[0]} - $${e[1]}`);
        });

        priceSlider.noUiSlider.on('change', function (e) {
            $("#from-price").val(e[0]);
            $("#to-price").val(e[1]);
            submitFilterForm().then(() => {
                scrollToElement('product-container');
            });
        });

        var weightSlider = document.getElementById('weight-slider');
        console.log(weightSlider);
        if(weightSlider){
            noUiSlider.create(weightSlider, {
                start: [0, 100],
                connect: true,
                step: 5,
                margin: 10,
                range: {
                    'min': 0,
                    'max': 100
                },
                format: {
                    to: function (value) {
                        return parseInt(value);
                    },
                    from: function (value) {
                        return parseInt(value);
                    }
                }
            });

            weightSlider.noUiSlider.on('slide', function (e) {
                $(".weight-slider-detail").html(`${e[0]}oz - ${e[1]}oz`);
            });

            weightSlider.noUiSlider.on('change', function (e) {
                $("#from-weight").val(e[0]);
                $("#to-weight").val(e[1]);
                submitFilterForm().then(() => {
                    scrollToElement('product-container');
                });
            });
        }

        $('.container--category').on('click', '.category-pagination a', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            $('.loading-frame').show();
            $.get(url, function (respond) {
                $('.container--category .product-container').html(respond);
                $('.loading-frame').hide();

                scrollToElement('product-container');
            });
        })

        $(".clear-link").click(function (e) {
            e.preventDefault();
            $('.filter-form input[type=checkbox]').prop('checked' ,false);
            $('.filter-form input[type=radio]').prop('checked' ,false);
            slider.noUiSlider.set([0, maxPrice]);
            $(".price-slider-detail").html(`$${0} - $${maxPrice}`);
            $("#from-price").val(0);
            $("#to-price").val(maxPrice);

            submitFilterForm().then(() => {
                scrollToElement('product-container');
            });
        });

        $('.filter-option').change(function () {
            if($(this).hasClass('filter-option--brand')){
                let checked = $(this).is(':checked');
                console.log(checked);
                $('.attribute-filters--brand input').prop('checked', false);
                if(checked){
                    $(this).prop('checked', true);
                }
            }
            submitFilterForm().then(() => {
                scrollToElement('product-container');
            });
        });

    }

    $('.accordion-row .accordion-row__heading').click(function () {
        var $parent = $(this).parent();
        $parent.toggleClass('active');
        if($parent.hasClass('active')){
            $parent.find('.accordion-row__body').slideDown();
        }else{
            $parent.find('.accordion-row__body').slideUp();
        }
    });

    $('.attribute-filters h5').click(function () {
        if($(this).next().is(':hidden')){
            $(this).parent().addClass('active');
            $(this).next().slideDown();
        }else{
            $(this).parent().removeClass('active');
            $(this).next().slideUp();
        }
    });

    $(document).on('click', '.btn-add-quote-to-cart', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        $('.loading-frame').show();
        $.get(url).then(response => {
            loadCartContent(response);
            $('.loading-frame').hide();
            showCartContent();
        });
    });

    $(document).on('click', '.btn-delete-quote', function (e) {
        e.preventDefault();
        var $this = $(this);
        if(window.confirm('Do you want to delete the selected quote?')){
           var url = $this.attr('href');
            $('.loading-frame').show();
            $.get(url).then(response => {
               $('.loading-frame').hide();
               $('.my-quote-container').html(response)
            });
        }
    });

    $('.header--quick-assess__cart').click(function (e) {
        e.preventDefault();
        showCartContent();
    })

    loadCartContent();

    $(document).on('click', '.cart__heading__close', function () {
        hideCartContent();
    });

    $(document).on('click', '.remove-cart-item-btn', function (e) {
        e.preventDefault();
        var $this = $(this);
        var $parent = $this.closest('.cart__body__item').slideUp();
        $parent.addClass('loading');
        if(window.confirm('Do you want to remove this item from cart?')){
            var url = $this.attr('href');
            $parent.slideUp();
            $.get(url, function (respond) {
                loadCartContent(respond);
            });
        }
    });


    $('.main-side-popup').click(function (e) {
        if(!$(e.target).closest('.cart-container').length || $(e.target).closest('.cart__heading__close').length){
            hideCartContent();
        }
    });


    $('.print-btn').click(function () {
        let title = $(this).attr('title');
        if(title){
            document.title = title;
        }
        window.print();
    });

    $('.btn-request-sample-toggle').click(function () {
        if($('.btn--add-to-request-sample.selected').length){
            $(this).parent().hide()
            $('.request-sample-form-container').slideDown();
        }else{
            window.alert('Please select at least 1 product');
        }

    });

    $('.btn--remove-from-favorite').click(function () {
        var url = $(this).attr('href');
        if(window.confirm('Do you want to delete this item from the favourite list?')){
            $.get(url);
            $(this).closest('.product-list__item').parent().slideUp();
        }
    });

    $('.btn--add-to-request-sample').click(function () {
        $(this).toggleClass('selected');
        updateSelectedProductIDs();
    })

    $('.btn-back').click(function (e) {
        e.preventDefault();
        window.history.back();
    });

    $('.filter-container-toggle-btn').click(function () {
        //$('.filter-container').toggleClass('active');

        if($('.filter-container').hasClass('active')){
            $('.filter-container').removeClass('active');
            $(this).text('Show Filters');
        }else{
            $('.filter-container').addClass('active');
            $(this).text('Hide Filters');
        }
    });

    $('.search-form__submit-btn').click(function () {
       $(this).closest('form').submit();
    });

    $('.share-quote-toggle-btn').click(function () {
        $(this).toggleClass('active');
        if($(this).hasClass('active')){
            $(".share-quote-form-container").slideDown();
        }else{
            $(".share-quote-form-container").slideUp();
        }
    });

    $('.share-retail-quote-toggle-btn').click(function () {
        $(this).toggleClass('active');
        if($(this).hasClass('active')){
            $(".share-retail-quote-form-container").slideDown();
        }else{
            $(".share-retail-quote-form-container").slideUp();
        }
    });


    if($("#Form_AssignForm_Email").length){
        var $input = $("#Form_AssignForm_Email");
        autocomplete({
            input: $input[0],
            minLength: 1,
            debounceWaitMs: 200,
            fetch: function(text, update) {
                text = text.toLowerCase();

                $.ajax({
                    url: "/manager/findCustomer",
                    data: {
                        'search': text
                    },
                    dataType: "json",
                    success: function (result) {
                        console.log(result);
                        update(result);
                    }
                }) ;


            },
            onSelect: function(item) {
                $input.val(item.label);
            }
        });
    }

    $("#quote-search-input").keyup(function () {
        var text = $(this).val();
        $.ajax({
            url: "/manager/quote",
            data: {
                'search': text
            },
            success: function (result) {
                $(".manager-quote-container").html(result);
            }
        }) ;
    });

    if($('.contact-form').length){
        $('select.region-select').change(function (){
            if($(this).val() == 'Auckland'){
                $('div.store-select').slideDown();
            }else{
                $('div.store-select').slideUp();
            }
        });
    }

});

function updateSelectedProductIDs() {
    var ids = '';
    $('.btn--add-to-request-sample.selected').each(function () {
        ids += $(this).attr('pid') + ',';
    });
    if(ids.length){
        ids = ids.slice(0, -1);
    }
    $('#selectedProducts').val(ids);
}

function loadCartContent(html) {
    if(html){
        $('.main-side-popup').html(html);

        let counter = $(".cart-container").attr('counter');
        $(".header--quick-assess__cart span").text(counter);
    }else{
        return $.get('/cart/detail/', function (respond) {
            $('.main-side-popup').html(respond);

            let counter = $(".cart-container").attr('counter');
            $(".header--quick-assess__cart span").text(counter);
        });
    }
}

function showCartContent() {
    $('body').addClass('cart-opened');
}

function hideCartContent() {
    $('body').removeClass('cart-opened');
}

function submitFilterForm() {
    let data = $('.filter-form').serialize();
    let url = $('.filter-form').attr('action');
    $('.loading-frame').show();
    return $.ajax({
        url: url,
        method: 'GET',
        data: data,
    }).done(function( html ) {
        $('.container--category .product-container').html(html);
        $('.loading-frame').hide();
    });
}

function scrollToElement(id) {
    let offsetPosition = $("#" + id).offset().top - $('header .menu-bar').height();
    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });

}
